<template>
    <div class="kefu-order-com f28">
      <div>物品数量：{{model.goodsNumber}}件</div>
      <div v-if='model.state != 119 && model.state != 129'>邮寄方式：{{model.pickingWayText}}</div>

      <div v-if='model.pickingWay == 10 && model.state != 119 && model.state != 129'>包拯地址：包拯工作室 17526857604 天津市武清区开发区武清逸仙园小区翠柳道6号（包拯修复中心）</div>
      <div v-if='model.pickingWay == 20 && model.state != 119 && model.state != 129'>取件时间：{{model.pickingDate?model.pickingDate.split(' ')[0]:''}}</div>
      <div v-if='model.pickingWay == 40 && model.state != 119 && model.state != 129'>取件时间：{{model.pickingDate}} {{model.pickingStartTime}}-{{model.pickingEndTime}}</div>
    </div>
</template>

<script>
  export default {
    name: 'kefu-order-com',
    props: {
      model : {
        type : Object,
        default : ()=>{
          return {
            pickingDate : ''
          }
        }
      }
    },
  }
</script>

<style scoped lang="scss">
  .kefu-order-com{
    background: #f6f6f6;
    padding: 20px 30px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    div{
      max-width: 690px;
      line-height: 50px;
      margin-bottom: 8px;
      &:last-child{
        margin: 0;
      }
    }
  }

</style>
